<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form
        ref="accountProgramForm"
        :model="accountProgramForm"
        label-width="80px"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="姓名">
              <el-input
                clearable
                v-model="accountProgramForm.userLike"
                placeholder="请输入用户姓名或ID"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="角色">
              <el-select
                clearable
                v-model="accountProgramForm.roleId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="所属商户">
              <el-input
                clearable
                v-model="accountProgramForm.queryParamLike"
                placeholder="请输入姓名或ID"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getUserList">查询</el-button>
            <el-button type="primary" @click="addUser">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="code" label="账号ID"> </el-table-column>
        <el-table-column prop="realName" label="姓名"> </el-table-column>
        <el-table-column prop="roleName" label="角色"> </el-table-column>
        <el-table-column label="所属商户">
          <template slot-scope="scope">
            <div v-html="formatterMerchantNames(scope.row.merchants)"></div>
          </template>
        </el-table-column>
        <el-table-column prop="serviceName" label="回收商名称"> </el-table-column>
        <el-table-column prop="phone" label="电话"> </el-table-column>
        <el-table-column prop="password" label="密码"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="status" label="账号状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">开启</span>
            <span v-if="scope.row.status === 0">关闭</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editorUser(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="openUser(scope.row.id)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >开启</el-button
            >
            <el-button
              @click="closeUser(scope.row.id)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >关闭</el-button
            >
            <el-button @click="deleteUser(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑账号' : '新建账号'"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <!-- {
        code: null,
        UserId: null,
        contactNumber: null,
        contactPerson: null,
        name: null,
        linkageId: null,
        merchantId: null,
      } -->
          <el-form ref="editUserForm" :model="editUserForm" label-width="120px">
            <el-form-item label="账号ID" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editUserForm.code"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="姓名"
              prop="realName"
              :rules="{
                required: true,
                message: '请输入账号名称',
                trigger: 'change',
              }"
            >
              <el-input clearable v-model="editUserForm.realName"></el-input>
            </el-form-item>
            <el-form-item
              label="角色"
              prop="roleIds"
              :rules="{
                required: true,
                message: '请选择角色',
                trigger: 'change',
              }"
            >
              <el-select clearable v-model="editUserForm.roleIds">
                <el-option label="超级管理员" :value="1"></el-option>
                <el-option label="商户" :value="5"></el-option>
                <el-option label="回收商管理员" :value="9"></el-option>
                <el-option label="质检员" :value="10"></el-option>
              </el-select>

              <!-- <el-select
                clearable
                v-model="editUserForm.roleIds"
                placeholder="请选择角色"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->

            </el-form-item>
            <el-form-item
              v-if="editUserForm.roleIds === 5"
              label="所属商户"
              prop="merchantIds"
              :rules="{
                required: true,
                message: '请选择所属商户',
                trigger: 'change',
              }"
            >
              <el-select
                clearable
                style="width:100%"
                v-model="editUserForm.merchantIds"
                filterable
                multiple
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :remote-method.sync="getMerchantList"
                :loading="loading"
              >
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              v-if="editUserForm.roleIds === 9"
              label="所属回收商"
              prop="serviceId"
              :rules="{
                required: true,
                message: '请选择所属回收商',
                trigger: 'change',
              }"
            >
              <el-select
                clearable
                style="width:100%"
                v-model="editUserForm.serviceId"
                filterable
                placeholder="请输入关键词"
                reserve-keyword
                :loading="loading"
              >
                <el-option
                  v-for="item in serviceProviderList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="电话"
              prop="phone"
              :rules="{
                required: true,
                message: '请填写电话',
                trigger: 'change',
              }"
            >
              <el-input clearable v-model="editUserForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input clearable v-model="editUserForm.password"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div
          style="text-align: center;"
          :rules="{ required: true, message: '请选择角色', trigger: 'change' }"
        >
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditorUserDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      accountProgramForm: {
        userLike: "",
        roleId: "",
        queryParamLike: "",
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editUserForm: {
        id: null,
        realName: null,
        code: null,
        merchantId: null,
        phone: null,
        password: null,
        type: 1,
        roleIds: null,
        status: 0,
        merchantIds: null,
        serviceId:null
      },

      dlgType: "change",

      // 商户选择
      merchatOptions: [],

      // 三级区域选择
      roleOptions: [],
      loading: false,

      prentIdOptions: [],

      serviceProviderList:[]
    };
  },
  watch: {},
  computed: {},
  methods: {
            //删除用户
    deleteUser(id){
      let self = this
        self.$confirm('是否删除').then(() => {
         self.$api.deleteUser({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getUserList()
          }
      })
      })
     
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },

    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求订单数据
      this.getUserList();
    },

    // 获取账号列表
    getUserList() {
      let self = this;
      
      self.$api
        .getUserList({
          types: [1,7],
          page: self.currentPage,
          size: self.pageSize,
          queryParamLike: self.accountProgramForm.queryParamLike || null,
          roleId: self.accountProgramForm.roleId || null,
          userLike: self.accountProgramForm.userLike || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加账号
    addUser() {
      this.dlgType = "new";
      this.editUserForm = {
        id: null,
        realName: null,
        code: null,
        merchantId: null,
        phone: null,
        password: null,
        type: 1,
        roleIds: null,
        status: 0,
        serviceId:null
      };
      this.$nextTick(()=>{
          this.$refs['editUserForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改账号
    editorUser(row) {
      let self = this;
      self.editUserForm = {
        id: null,
        realName: null,
        code: null,
        merchantId: null,
        phone: null,
        password: null,
        type: 1,
        roleIds: null,
        status: 0,
        merchantIds: null,
        serviceId:null
      };

      self.dlgType = "change";

      for (let i in self.editUserForm) {
        if (i === "roleIds") {
          self.editUserForm.roleIds = row.roleId;
        } else if (i === "merchantIds") {
          let merchantIds = [];
          for (let each = 0; each < row.merchants.length; each++) {
            merchantIds.push(row.merchants[each].id);
          }
          self.editUserForm.merchantIds = merchantIds;
        } else {
          if (row[i]) self.editUserForm[i] = row[i];
        }
      }
      console.log(self.editUserForm);
      self.isDlg = true;
    },

    // 关闭编辑对话框
    closeEditorUserDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editUserForm"].validate((valid) => {
        if (valid) {
          let params = {};
          for (let i in self.editUserForm) {
            if (i === "roleIds") {
              params.roleIds = [];
              params.roleIds = self.editUserForm[i];
            } else if (i === "merchantIds") {
              params.merchantIds = self.editUserForm[i].join(",");
            } else {
              params[i] = self.editUserForm[i];
            }
          }
          params.type= params.roleIds ===9 ?7:1
          if (self.dlgType === "change") {
            self.$api.changeUser(params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.getUserList();
                this.closeEditorUserDlg();
              }
            });
          } else {
            self.$api.addUser(params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getUserList();
                this.closeEditorUserDlg();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //获取回收商
    getValidHjxServiceProvider(){
      let self = this;
      self.$api
        .getValidHjxServiceProvider()
        .then((res) => {
          if (res.code === 200) {
            self.serviceProviderList = res.data;
          }
        });
    },

    // 请求商户列表
    getMerchantList(param) {
      let self = this;
      self.$api
        .getMerchantList({
          merchantLike: param,
          page: 1,
          size: 100000,
          status: 1,
        })
        .then((res) => {
          if (res.code === 200) {
            self.merchatOptions = res.data.records;
          }
        });
    },

    // 请求区域
    getRoleList() {
      let self = this;
      self.$api
        .getRoleList({
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self.roleOptions = res.data.records;
          }
        });
    },

    // 开启账号
    openUser(id) {
      this.$api.openUser(id).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "开启成功",
            type: "success",
          });
          this.getUserList();
        }
      });
    },

    // 关闭账号
    closeUser(id) {
      this.$api.closeUser(id).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "关闭成功",
            type: "success",
          });
          this.getUserList();
        }
      });
    },
    formatterMerchantNames(merchants) {
      let merchantNames = "";
      for (let i = 0; i < merchants.length; i++) {
        merchantNames += merchants[i].name + ",";
      }
      return merchantNames == ""
        ? ""
        : merchantNames.substring(0, merchantNames.length - 1);
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getUserList();

    self.getMerchantList();
    self.getRoleList();

    self.getValidHjxServiceProvider();
  },
};
</script>
<style lang="less" scoped></style>
